import React from 'react';
import { GridEditorState, GridEditorActions } from '../../GridEditorPresenter';
import { GeoJSONImporter } from '../GeoJSONImporter';
import { Layers } from 'lucide-react';

interface GeoJSONPanelProps {
  geoJSONLayers: GridEditorState['geoJSONLayers'];
  mapCenter: GridEditorState['mapCenter'];
  elements: GridEditorState['elements'];
  actions: Pick<GridEditorActions, 'handleLayerAdd' | 'handleLayerRemove' | 'handleLayerUpdate' | 'handleElementsAdd' | 'handleConnectionsAdd' | 'getMapBounds'>;
}

export const GeoJSONPanel: React.FC<GeoJSONPanelProps> = ({
  geoJSONLayers,
  mapCenter,
  elements,
  actions
}) => {
  return (
    <div className="p-4 border-b border-slate-200">
      <h3 className="text-sm font-medium text-slate-900 mb-3 flex items-center">
        <Layers className="h-4 w-4 mr-2" />
        Couches GeoJSON
      </h3>
      
      <GeoJSONImporter
        layers={geoJSONLayers}
        onLayerAdd={actions.handleLayerAdd}
        onLayerRemove={actions.handleLayerRemove}
        onLayerUpdate={actions.handleLayerUpdate}
        onElementsAdd={actions.handleElementsAdd}
        onConnectionsAdd={actions.handleConnectionsAdd}
        existingElements={elements}
        mapBounds={actions.getMapBounds()}
      />
    </div>
  );
};
